import { StatusColor } from 'types/Status';
import { OperationStatus } from 'types/Operation';
import StatusColors from 'const/statusColors';

export const getDossierOperationStatusColor = (
  status: OperationStatus,
): StatusColor => {
  switch (status) {
    case OperationStatus.Eligible:
    case OperationStatus.BonPourPrime:
    case OperationStatus.PreValide:
      return StatusColors.Vert;

    case OperationStatus.AConfirmer:
    case OperationStatus.DossierEnCoursDeValidation:
    case OperationStatus.RemisAuControle:
    case OperationStatus.ActionEnCours:
      return StatusColors.Orange;

    case OperationStatus.NonConfirme:
    case OperationStatus.Annule:
    case OperationStatus.Incomplet:
    case OperationStatus.NonConforme:
    case OperationStatus.Litige:
    case OperationStatus.Refuse:
      return StatusColors.Rouge;

    case OperationStatus.Recommandations:
    default:
      return StatusColors.Gris;
  }
};
